<template>
  <div class="tablediv box">
    <div class="box_f1 box box_v">
      <dv-decoration-7>　{{title}}　</dv-decoration-7>
      <div class="box_f1">
        <dv-border-box-8>
          <dv-scroll-board :config="config" />
        </dv-border-box-8>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'csscAllTable',
    computed: {
      xiaofeiquanVue() {
        return this.$store.state.xiaofeiquanVue
      },
    },
    created() {
      this.config = this.getConfig([['', '', '', '']])
      //4大类总消费金额排名
      //04--超市，05--商场,06--家电，07--金银珠宝,
      let resobj = {
        '04':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸市阳光超市有限公司新世纪店-超市","goodsAmount":803648.03,"consumeNum":8833},{"companyName":"河北美食林商贸集团有限公司滏东购物广场(美食林滏东购物广场)","goodsAmount":760034.66,"consumeNum":8531},{"companyName":"河北美食林商贸集团有限公司新城购物广场-超市","goodsAmount":620923.94,"consumeNum":6688},{"companyName":"河北美食林商贸集团有限公司新宇购物广场(美食林新宇购物广场)","goodsAmount":612026.28,"consumeNum":6680},{"companyName":"天鸿店-阳光超市","goodsAmount":420903.78,"consumeNum":4678},{"companyName":"河北美食林商贸集团有限公司环球购物广场(美好之家)","goodsAmount":379962.46,"consumeNum":3993},{"companyName":"邯郸市阳光超市有限公司前进店（前进店)","goodsAmount":358620.36,"consumeNum":3817},{"companyName":"河北美食林商贸集团有限公司千百家分公司","goodsAmount":340663.74,"consumeNum":3734},{"companyName":"河北美食林商贸集团有限公司邯郸鑫港分公司(美食林鑫港购物广场)","goodsAmount":338781.29,"consumeNum":3580},{"companyName":"河北美食林商贸集团有限公司涉县春天分公司---超市","goodsAmount":297317.15,"consumeNum":3290}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '07':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸阳光新世纪股份有限公司-金银珠宝","goodsAmount":2121849.1,"consumeNum":509},{"companyName":"邯郸市赵都黄金珠宝有限公司","goodsAmount":423028.2,"consumeNum":107},{"companyName":"邯郸万达工贸有限公司—金银珠宝","goodsAmount":356178.6,"consumeNum":95},{"companyName":"邯郸市阳光新龙商贸有限公司天鸿广场分公司-金银珠宝","goodsAmount":29615,"consumeNum":7}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '06':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸市阳光三联电器有限公司-家电","goodsAmount":15877680.2,"consumeNum":9180},{"companyName":"邯郸苏宁易购商贸有限公司丛台稽山新天地店","goodsAmount":2159620.7,"consumeNum":1416},{"companyName":"邯郸苏宁易购商贸有限公司","goodsAmount":1249565.9,"consumeNum":713},{"companyName":"邯郸苏宁易购商贸有限公司丛台区美乐城店","goodsAmount":986411.2,"consumeNum":591},{"companyName":"邯郸国美电器有限公司","goodsAmount":310147,"consumeNum":165},{"companyName":"邯郸市康德超级市场有限公司—家电","goodsAmount":242405,"consumeNum":231},{"companyName":"河北美食林商贸集团有限公司成安分公司—步步高","goodsAmount":1598,"consumeNum":1}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1},
        '05':{"isSucceed":true,"message":"","rows":[{"companyName":"邯郸阳光新世纪股份有限公司-百货餐饮","goodsAmount":6646969.22,"consumeNum":25378},{"companyName":"邯郸万达工贸有限公司—百货餐饮","goodsAmount":5005432.24,"consumeNum":37763},{"companyName":"邯郸市阳光新龙商贸有限公司天鸿广场分公司-百货餐饮","goodsAmount":2661512.97,"consumeNum":15865},{"companyName":"邯郸市丛台区国风购物中心","goodsAmount":1009034,"consumeNum":8316},{"companyName":"邯郸市阳光三联电器有限公司-百货餐饮","goodsAmount":656035.2,"consumeNum":4841},{"companyName":"邯郸市康德超级市场有限公司—百货餐饮","goodsAmount":361311,"consumeNum":2858},{"companyName":"邯郸市美乐百货管理有限公司(美乐百货)","goodsAmount":316982.3,"consumeNum":2090},{"companyName":"河北美食林商贸集团有限公司滏东购物广场","goodsAmount":262148.8,"consumeNum":2269},{"companyName":"邯郸市阳光超市有限公司人民路分公司-百货.餐饮","goodsAmount":234584.1,"consumeNum":1655},{"companyName":"御品鲜卤(永安店)","goodsAmount":66300,"consumeNum":663}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
      }
      // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/top',{
      //   discountCouponTypeNO: this.type
      // },res=> {
        let res = resobj[this.type]
        let data = res.rows.map(item=> {
          return ['<span title="'+item.companyName+'">'+item.companyName+'</span>',
            '<span title="'+item.goodsAmount+'">'+this.toThousands(item.goodsAmount, true)+'</span>',
            '<span title="'+item.consumeNum+'">'+this.toThousands(item.consumeNum, true)+'</span>']
        })
        this.config = this.getConfig(data)
      // })
    },
    methods: {
      getConfig(data) {
        if(data.length<1) {
          data = [['', '', '', '']]
        }
        return {
          header: ['企业名称', '消费总金额(元)', '核销总数(张)'],
          data: data,
          index: true,
          waitTime: 3000,
          headerBGC: 'rgba(29, 193, 245,.5)',
          oddRowBGC: '',
          evenRowBGC: '',
          columnWidth: [50, 230],
          align: ['center', 'left', 'center','center']
        }
      },
      toThousands(_num, bol) {
        _num = _num.toFixed(4)*1
        let numArr = (_num+'').split('.')
        let num = parseInt(numArr[0])
        let xs = numArr[1]?numArr[1]:''

        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(xs) {
          result = [...result, '.', ...xs.split('')]
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      },
      _toThousands(num, bol) {
        num = parseInt(num)
        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      }
    },
    data () {
      return {
        config: {}
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less">
  .tablediv {
    position: relative;
    width: 100%;
    height: 50%;

    .dv-scroll-board {
      height: 100%;
    }
    .dv-border-box-8 {
      .border-box-content {
        padding: 10px!important;
      }
    }
    .dv-decoration-7 {
      height: 25px;
      margin: 20px 0px!important;
      font-size: 16px;
    }
  }
</style>
